var _path, _path2, _g, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWikiMenuLuxury(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9394 9.0625C12.985 9.67762 9.02495 15.378 7.38391 17.7746C6.95805 18.3965 7.00991 19.2238 7.50383 19.7932L17.1717 30.9375C17.7104 31.4583 19.0303 32.5 20 32.5C20.9697 32.5 22.2895 31.4583 22.8282 30.9375L32.5506 19.7303C33.0185 19.191 33.0926 18.417 32.7246 17.8051C31.294 15.4268 27.7425 9.68025 26.4646 9.0625C24.8484 8.28125 22.5858 7.5 20 7.5C17.4141 7.5 15.1515 8.28125 13.9394 9.0625Z",
    fill: "#D1CFCD"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1451_18044",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 26,
    height: 26
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9394 9.0625C12.985 9.67762 9.02496 15.378 7.38391 17.7746C6.95805 18.3965 7.00991 19.2238 7.50383 19.7932L17.1717 30.9375C17.7104 31.4583 19.0303 32.5 20 32.5C20.9697 32.5 22.2895 31.4583 22.8282 30.9375L32.5506 19.7303C33.0185 19.191 33.0926 18.417 32.7246 17.8051C31.294 15.4268 27.7425 9.68025 26.4646 9.0625C24.8484 8.28125 22.5858 7.5 20 7.5C17.4141 7.5 15.1515 8.28125 13.9394 9.0625Z",
    fill: "url(#paint0_linear_1451_18044)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1451_18044)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 33.2812L12.9412 18.4375L27.0588 18.4375L20.0001 33.2812Z",
    fill: "#ACA39C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 32.8906L27.0588 18.4375L34.9019 18.4375L23.5293 31.3281L19.9999 32.8906Z",
    fill: "#5C5B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 33.2813L12.9411 18.4375L5.09803 18.4375L16.4706 31.6765L20 33.2813Z",
    fill: "#5C5B5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 7.5L27.0588 18.4375H12.9412L19.9999 7.5Z",
    fill: "#ECECEC"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 1.66663L36.7678 4.89886L40 6.66663L36.7678 8.43439L35 11.6666L33.2322 8.43439L30 6.66663L33.2322 4.89886L35 1.66663Z",
    fill: "#FF791C"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1451_18044",
    x1: 13.9394,
    y1: 9.0625,
    x2: 27.1922,
    y2: 21.0669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#95E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1ED2FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWikiMenuLuxury);
export default __webpack_public_path__ + "static/media/wikiMenuLuxury.2b594a26188c4882889a4d10723f1c90.svg";
export { ForwardRef as ReactComponent };